import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { Button } from "@novaescola/eva-react-v2";

import { AccountApi } from "../../../api/account/account.api";

const COOKIE_NAME = "ane-confirmation-block_yhbh327kfyj";
const COOKIE_REMATRICULA_NAME = "ane-confirmation-block_bfef93f29c";
const COOKIE_CLOSE_NAME = "ane-confirmation-block_close";
const ETAPAS = {
  EDUCACAO_INFANTIL_CRECHE: { text: "Creche", id: "8eubdhev4md" },
  EDUCACAO_INFANTIL_PRE_ESCOLA: {
    text: "Pré-escola",
    id: "vorihvq9w98",
  },
  ENSINO_FUNDAMENTAL_ANOS_INICIAIS: {
    text: "Ensino Fundamental 1",
    id: "ro2c77bnzfh",
  },
  ENSINO_FUNDAMENTAL_ANOS_FINAIS: {
    text: "Ensino Fundamental 2",
    id: "29dy1desreu",
  },
  ENSINO_MEDIO: { text: "Ensino Médio", id: "6vb1i2cpgjv" },
  EJA: { text: "EJA", id: "8y86ynlzg6a" },
};

export const ConfirmationBlockEtapa = ({ user, fetchUser }) => {
  const [hidden, setHidden] = useState(true);
  const [etapas, setEtapas] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const token = Cookies.get("Bearer");

    setAccessToken(token);
    setHidden(false);

    if (user.etapas && user.etapas.length > 0)
      setEtapas(user.etapas.map((el) => el.etapas));

    sendEventToDataLayer(
      "block_visualization",
      "JORNALISMO: matrícula - complementação de cadastro - etapa - bloco visualizado"
    );
  }, []);

  const sendEventToDataLayer = (event, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, label });
  };

  const handleChange = (event) => {
    const set = new Set(etapas);

    if (event.target.checked) {
      if (!set.has(event.target.value)) {
        set.add(event.target.value);
        setEtapas(Array.from(set));
      }
    } else {
      if (set.has(event.target.value)) {
        set.delete(event.target.value);
        setEtapas(Array.from(set));
      }
    }
  };

  const handleSubmit = async () => {
    setSubmitted(true);

    const response = await AccountApi.updateUserEtapas(accessToken, etapas);

    if (!response) {
      const expires = new Date();
      expires.setUTCDate(expires.getUTCDate() + 1);

      Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
      setHidden(true);

      return;
    }

    fetchUser(accessToken);

    const dtUltimaModificacao = new Date(user.dtUltimaModificacao);

    const lastYear = new Date();
    lastYear.setMonth(lastYear.getMonth() - 12);

    const finalEventLabel =
      user.etapas &&
      user.etapas.length > 0 &&
      (dtUltimaModificacao < lastYear || Cookies.get(COOKIE_REMATRICULA_NAME))
        ? " - rematrícula"
        : "";

    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - etapa - botão enviar${finalEventLabel}`
    );

    const expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 1);

    etapas.forEach((etapa) => {
      sendEventToDataLayer(
        "confirmation_block",
        `JORNALISMO: matrícula - complementação de cadastro - etapa - ${ETAPAS[etapa].text}`
      );

      Cookies.set(`ane-confirmation-block_${ETAPAS[etapa].id}`, "true", {
        expires,
      });
    });

    Cookies.set(COOKIE_NAME, "true", { expires });
    setHidden(true);
  };

  const handleClose = () => {
    const expires = new Date();
    expires.setUTCDate(expires.getUTCDate() + 1);

    Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
    setHidden(true);

    sendEventToDataLayer(
      "confirmation_block",
      "JORNALISMO: matrícula - complementação de cadastro - etapa - botão sair"
    );
  };

  if (hidden) {
    return null;
  }

  return (
    <div className="eva-bg-inst-50 eva-margin-bottom-3 eva-pr-05 eva-pl-05 eva-pb-05 eva-pt-05 confirmation-block">
      <div className="eva-mb-03 confirmation-block-title">
        <i className="far fa-circle-question eva-mr-03" />
        Em qual etapa de ensino você leciona?
      </div>
      <div className="confirmation-block-options">
        {Object.entries(ETAPAS).map(([value, { text, id }]) => (
          <div className="eva-fields-checkbox" key={`etapa-option-${id}`}>
            <input
              type="checkbox"
              className="eva-checkbox eva-cursor-pointer"
              id={id}
              value={value}
              onChange={handleChange}
              checked={etapas.includes(value)}
            />
            <label htmlFor={id} className="eva-label-checkbox">
              {text}
            </label>
          </div>
        ))}
      </div>
      <div className="eva-mt-05">
        <Button
          type="button"
          variant="primary"
          size="small"
          disabled={submitted || etapas.length === 0}
          onClick={handleSubmit}
        >
          Enviar
        </Button>
      </div>
      <button
        type="button"
        aria-label="Fechar"
        className="eva-cursor-pointer confirmation-block-close"
        onClick={() => handleClose()}
      >
        <i className="far fa-times"></i>
      </button>
    </div>
  );
};
